const {
  validate: validateVA,
} = require('wallet-address-validator');


const PATTERN_TRC = 'TRX';
const PATTERN_ERC = 'ETH';
const PATTERN_BEP = 'ETH';

const NETWORKS = {
  BTC: 'BTC',
  TRX: PATTERN_TRC,
  TRON: PATTERN_TRC,
  TRC: PATTERN_TRC,
  ETH: PATTERN_ERC,
  BNB: PATTERN_BEP,
  BSC: PATTERN_BEP,
};

module.exports = (address, network) => {
  try {
    if (!address) return;
    if (network === 'SOL') return /[1-9A-HJ-NP-Za-km-z]{32,44}/g.test(address);

    return validateVA(
      address,
      NETWORKS[network] || network,
    );
  } catch (e) {
    console.error(e);
  }
  return false;
};

